import { render } from "./DiscussionContent.vue?vue&type=template&id=2a204cba&scoped=true"
import script from "./DiscussionContent.vue?vue&type=script&lang=js"
export * from "./DiscussionContent.vue?vue&type=script&lang=js"

import "./DiscussionContent.vue?vue&type=style&index=0&id=2a204cba&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a204cba"]])

export default __exports__